<template>
  <div class="withdraw">
    <Row class="detail-header">
      <span>撤诉</span>
      <Button
        v-if="!state&&defaultData" type="primary"
        style="margin-left: 15px" @click="edit()"
      >修改</Button>
      <Button
        v-if="!state&&defaultData&&defaultData.auditState=='P'" :disabled="isSubmit"
        type="primary" class="add-btn"
        @click="cancel"
      >撤回撤诉</Button>
    </Row>
    <Row class="case-content">
      <Form
        v-if="!infoCtrl" ref="formValidate"
        :model="formValidate" :disabled="caseState=='TN'"
        :label-width="100" style="height:100%"
      >
        <FormItem
          label="选择节点" prop="nodeData"
          :rules="[{ required: true,type:'number', message: '请选择节点', trigger: 'change' }]"
        >
          <RadioGroup v-model="formValidate.nodeData" @on-change="changeNode">
            <Radio
              v-for="(item,index) in nodeReduceData" :key="index"
              :label="item.nodeIndex"
            >{{ item.name }}</Radio>
          </RadioGroup>

        </FormItem>
        <FormItem
          v-if="!isEdit || isEdit && defaultData.auditState!='E'" label="撤诉对象"
          prop="member"
          :rules="[{ required: true, type:'array', message: '撤诉对象不能为空', trigger: 'change' }]"
        >
          <Select
            v-model="formValidate.member" multiple
            placeholder="请选择撤诉对象" label-in-value
            @on-change="getMember"
          >
            <Option
              v-for="item in litigantIdArr" :key="item.id"
              :value="item.id"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem
          v-if="isEdit && defaultData.auditState=='E'" label="撤诉对象"
          prop="selectIdArr"
        >
          <Input :value="defaultData.litigantNames" disabled />
        </FormItem>
        <FormItem
          label="撤诉原因" prop="reason"
          :rules="[{ required: true, message: '撤诉原因不能为空', trigger: 'blur' },{max:512,message:'长度不能超过512个字符',trigger:'blur'}]"
        >
          <Input
            v-model.trim="formValidate.reason" type="textarea"
            :autosize="{minRows: 3,maxRows: 8}" placeholder="请填写撤诉原因"
          />
        </FormItem>
        <FormItem
          v-if="!isEdit || isEdit && defaultData.auditState!='E'" label="撤诉申请文件"
          prop="attachmentList"
          :rules="[{ required: true,type:'array', message: '附件不能为空', trigger: 'blur' }]"
        >
          <file-upload
            :default-list="defaultList || []"
            :upload-config="uploadConfig"
            @getFileList="getAttachmentList"
          />
        </FormItem>
        <FormItem
          v-if="isEdit && defaultData.auditState=='E'" label="撤诉申请文件"
          prop="attachmentList"
          :rules="[{ required: true,type:'array', message: '附件不能为空', trigger: 'blur' }]"
        >
          <file-upload
            :default-list="defaultData.attachmentList || []"
            :upload-config="{readOnly:true}"
          />
        </FormItem>
        <FormItem
          label="变更诉讼要求" prop="changeState"
          :rules="[{ required: true, message: '变更诉讼要求不能为空', trigger: 'change' }]"
        >
          <RadioGroup v-model="formValidate.changeState">
            <Radio label="true">是</Radio>
            <Radio label="false">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          v-if="formValidate.changeState=='true'" label="变更金额"
          prop="changeAmout"
          :rules="[{ required: true, type: 'any', message: '变更金额不能为空', trigger: 'blur' },{validator:overMillion, trigger: 'blur'}]"
        >
          <my-input
            append-text="￥"
            :default-data="formValidate.changeAmout"
            :to-fixed="2"
            @getValue="getInputValue($event,'changeAmout')"
          />
        </FormItem>
        <FormItem
          label="是否退费" prop="returnState"
          :rules="[{ required: true, message: '是否退费不能为空', trigger: 'change' }]"
        >
          <RadioGroup v-model="formValidate.returnState">
            <Radio label="true">是</Radio>
            <Radio label="false">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          v-if="formValidate.returnState=='true'" label="退费金额"
          prop="returnAmout"
          :rules="[{ required: true,type: 'any', message: '退费金额不能为空', trigger: 'blur' },{validator:overMillion, trigger: 'blur'}]"
        >
          <my-input
            append-text="￥"
            :default-data="formValidate.returnAmout"
            :to-fixed="2"
            @getValue="getInputValue($event,'returnAmout')"
          />
        </FormItem>
        <FormItem
          v-if="formValidate.changeState=='true'" label="相关附件"
          prop="attachmentListAtt"
        >
          <file-upload
            :default-list="defaultListAtt || []"
            :upload-config="uploadConfigAtt"
            @getFileList="getAttachmentListAtt"
          />
        </FormItem>

        <Row class="detail-btn-box">
          <Button
            type="primary" style="margin-right:10px;"
            :disabled="isSubmit" @click="submit"
          >保存</Button>
          <Button @click="infoCtrl=true">取消</Button>
        </Row>
      </Form>
      <Row v-if="infoCtrl" class="detail-content">
        <Row><Col span="5" class="left-label">选择节点：</Col><Col span="16" class="right-content">{{ defaultData.prevNodeName }}</Col></Row>
        <Row><Col span="5" class="left-label">撤诉对象：</Col><Col span="16" class="right-content">{{ defaultData.litigantNames }}</Col></Row>
        <Row><Col span="5" class="left-label">撤诉原因：</Col><Col span="16" class="right-content">{{ defaultData.reason }}</Col></Row>
        <Row>
          <Col span="5" class="left-label">撤诉附件：</Col>
          <Col span="16" class="right-content">
            <file-upload
              :default-list="defaultData.attachmentList || []"
              :upload-config="{readOnly:true}"
            />
          </Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">审核状态：</Col>
          <Col span="16" class="right-content">
            <Tag style="border-radius:11px;" :color="getTagColor(defaultData.auditState)">
              <span v-if="defaultData.auditState=='P'">待审核</span>
              <span v-if="defaultData.auditState=='E'">审核通过</span>
              <span v-if="defaultData.auditState=='R'">审核驳回</span>
            </Tag>
          </Col>
        </Row>
        <Row v-if="defaultData.auditState=='R'"><Col span="5" class="left-label">审核备注：</Col><Col span="16" class="right-content">{{ defaultData.auditRemark }}</Col></Row>
        <Row>
          <Col span="5" class="left-label">变更诉讼要求：</Col><Col span="16" class="right-content">{{ justShowChangeState ? '是' : '否' }}
          </Col>
        </Row>
        <Row v-if="justShowChangeState">
          <Col span="5" class="left-label">变更金额：</Col>
          <Col span="16" class="right-content">{{ common.formateNumber(justShowChangeAmout) }}
          </Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">是否退费：</Col>
          <Col span="16" class="right-content">{{ justShowReturnState ? '是' : '否' }}
          </Col>
        </Row>
        <Row v-if="justShowReturnState">
          <Col span="5" class="left-label">退费金额：</Col>
          <Col span="16" class="right-content">{{ common.formateNumber(justShowReturnAmout) }}
          </Col>
        </Row>
        <Row v-if="justShowChangeState">
          <Col span="5" class="left-label">相关附件：</Col>
          <Col span="16" class="right-content">
            <file-upload
              :default-list="resultAttachmentList || []"
              :upload-config="{readOnly:true}"
            />
          </Col>
        </Row>

      </Row>
    </Row>
    <!-- 撤诉结果 -->
    <!-- <withdrawResult v-if="state" :withdrawId="editId" :caseId="caseId" :editState="editState" :processId="processId"></withdrawResult> -->
    <!-- <withdrawResult :withdraw-id="editId" :case-id="caseId" :node-id="nodeId" :edit-state="editState" :process-id="processId" /> -->
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
export default {
  props: ['caseId', 'processId', 'nodeId', 'editState', 'caseState', 'tabActive', 'prevProcessId', 'isButtonClick'],
  data () {
    const overMillion = (rule, value, callback) => {
      if (Number(value) > 100000000) {
        return callback(new Error('金额不能超过一亿'))
      }
      callback()
    }
    return {
      overMillion,
      styles: styles,
      editId: '',
      isEdit: false, // 是否修改
      litigantIdArr: [],
      withdrawId: '',
      justShowReturnState: '',
      justShowChangeState: '',
      justShowChangeAmout: '',
      justShowReturnAmout: '',
      resultAttachmentList: [],
      formValidate: {
        id: '',
        member: [],
        reason: '',
        memberName: '',
        attachmentList: [],
        changeState: 'true',
        changeAmout: '',
        returnState: 'true',
        returnAmout: '',
        attachmentListAtt: [],
        resultVOId: '',
        nodeData: ''
      },
      nodeReduceData: [],
      uploadConfig: {
        fileName: '',
        maxNum: 1
      },
      defaultList: [],
      uploadConfigAtt: {
        fileName: '',
        maxNum: 1
      },
      defaultListAtt: [],
      isSubmit: false,
      infoCtrl: false,
      defaultData: '',
      state: ''

    }
  },
  watch: {
    isButtonClick(nV, oV) {
      console.log(nV, oV)
      if (nV) {
        this.defaultData = ''
        this.infoCtrl = false
        this.defaultList = []
        Object.keys(this.formValidate).forEach(key => {
          if (key !== 'member' && key !== 'attachmentList' && key !== 'attachmentListAtt') {
            this.$set(this.formValidate, key, '')
          } else {
            this.$set(this.formValidate, key, [])
          }
        })
      } else {
        this.getDefaultData()
      }
    }
  },
  created() {
    //

  },
  beforeMount() {
    console.log('this.caseId', this.caseId)
    console.log('this.processId', this.processId)
    console.log('this.nodeId', this.nodeId)

    console.log('this.tabActive', this.tabActive)

    this.getLitigantIdArr()
    this.isButtonClick ? '' : this.getDefaultData()
    this.getNodeData()

    // if(this.prevProcessId && this.prevProcessId !== ''){
    //   this.formValidate.nodeData = this.prevProcessId
    // }
  },
  mounted() {

  },
  updated() {},
  methods: {
    edit() {
      this.isEdit = true
      this.getDefaultData('edit')
    },
    cancel() {
      this.isSubmit = true
      this.$patch(`/business/case/withdraw/back/${this.withdrawId}`).then(res => {
        this.isSubmit = false
        if (res.code === 0) {
          this.$Message.success('操作成功')
          this.$emit('reloadProcess')
        } else {
          this.$Message.error(res.message)
        }
        this.getDefaultData()
      })
    },
    getNodeData() {
      const url = '/business/case/process/optional?optional=3&caseId=' + this.caseId
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.nodeReduceData = res.data
        }
      })
    },
    // 选择节点
    changeNode(data) {
      console.log(data, 'data')
      this.formValidate.nodeData = data
    },
    // 获取节点数据
    // getNodeData(){
    //   const url = '/business/case/process?caseId=' + this.caseId
    //       return this.$get(url).then(async res => {
    //         if (res.code === 0) {

    //           this.nodeList = res.data
    //           this.nodeList.forEach(data=>{
    //             if(data.code == 'PL' && data.logList.length == 0){
    //                 this.nodeNewArr = this.nodeList.filter(item =>item.code !== 'PL')
    //             }else if(data.code == 'PL' && data.logList.length > 0){
    //               this.nodeNewArr = this.nodeList.filter(item =>item.code !== 'RR')
    //             }
    //           })

    //       this.nodeReduceData = this.nodeNewArr.reduce((newArr,item)=>{
    //         if(item.optionalNode && item.optionalNode.length){
    //             item.optionalNode.forEach(each=>{
    //               if(each.code==this.tabActive){
    //                 newArr.push(item)
    //                 newArr.forEach(newData=>{
    //                       if(newData.code == 'PN_BB'){ // 诉讼方案
    //                         newData.byname = '受理前'
    //                       }else if(newData.code == 'RR' || newData.code == 'PL'){ // 起诉或庭前
    //                         newData.byname = '已受理待开庭'
    //                       }else if(newData.code == 'CG_CG'){//庭审
    //                         newData.byname = '已开庭待判决'
    //                       }else if(newData.code == 'JT_BB'){// 判决
    //                         newData.byname = '已判决待执行'
    //                       }else if(newData.code == 'CO_CO'){//执行
    //                         newData.byname = '申请执行后'
    //                       }else if(newData.code == 'RE_AP'){ // 和解
    //                         newData.byname = '和解'
    //                       }else if(newData.code == 'ME_AP'){ // 调解
    //                         newData.byname = '调解'
    //                       }else if(newData.code == 'WD_AP'){
    //                         newData.byname = '撤诉'
    //                       }
    //                     })
    //                     console.log('数据最终结果',newArr)
    //               }
    //             })
    //           }
    //           return newArr
    //         },[])

    //         }
    //       })
    // },
    getInputValue(data, name) {
      this.formValidate[name] = data
    },
    getTagColor(state) {
      const obj = {
        'P': styles.warningColor,
        'E': styles.successColor,
        'R': styles.errorColor
      }
      return obj[state]
    },
    // 获取图片列表
    getAttachmentList (arr) {
      this.formValidate.attachmentList = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formValidate.attachmentList.push(obj)
      })
    },
    getAttachmentListAtt (arr) {
      this.formValidate.attachmentListAtt = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formValidate.attachmentListAtt.push(obj)
      })
    },
    getMember(data) {
      this.formValidate.memberName = data.length > 0 ? data.map(item => {
        return item.label
      }).join(',') : ''
    },
    submit() {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          const url = '/business/case/withdraw/mini'
          const ajaxData = {
            caseWithdrawVO: {
              prevNodeIndex: this.formValidate.nodeData,
              selectIdArr: this.formValidate.member, // 撤诉对象
              litigantIds: this.formValidate.member.length > 0 ? this.formValidate.member.join(',') : '',
              litigantNames: this.formValidate.memberName,
              reason: this.formValidate.reason,
              caseId: this.caseId,
              nodeId: this.nodeId,
              attachmentList: this.formValidate.attachmentList,
              id: this.defaultData ? this.defaultData.id : ''

            },
            resultVO: {
              prevNodeIndex: this.formValidate.nodeData,
              changeState: this.formValidate.changeState == 'true' ? 1 : 0,
              returnState: this.formValidate.returnState == 'true' ? 1 : 0,
              changeAmout: this.formValidate.changeAmout,
              returnAmout: this.formValidate.returnAmout,
              attachmentList: this.formValidate.attachmentListAtt, // 撤诉对象
              caseId: this.caseId,
              id: this.defaultData ? this.defaultData.resultVO.id : '',
              succeed: true
            }
          }

          this.isSubmit = true
          if (this.isEdit) {
            // ajaxData.id = this.editId

            this.$post(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code === 0) {
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
                this.isEdit = false
              } else {
                this.$Message.error(res.message)
              }
              this.getDefaultData()
            })
          } else {
            if (this.formValidate.nodeData && this.formValidate.nodeData !== '') {
              this.nodeReduceData.forEach(item => {
                if (item.nodeIndex == this.formValidate.nodeData) {
                  ajaxData.caseWithdrawVO.processId = item.processId
                }
              })
            }

            this.$post(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code === 0) {
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
              this.getDefaultData()
            })
          }
        }
      })
    },
    // 获取详情
    async getDefaultData(type) {
      // const url = `/business/case/withdraw/${this.processId}`
      // this.$get(url).then(res => {
      //   if (res.code === 0 && res.data) {
      //     this.defaultData = res.data
      //     this.state = res.data.auditState === 'E'
      //     this.editId = res.data.id
      //     this.infoCtrl = type !== 'edit'
      //     if (type === 'edit') {
      //       this.getDetail(this.defaultData)
      //     }
      //   } else {
      //     this.infoCtrl = false
      //     this.state = false
      //   }
      // })

      const url = `/business/case/withdraw/${this.processId}  `
      await this.$get(url).then(res => {
        if (res.code === 0 && res.data) {
          this.defaultData = res.data
          this.editId = res.data.id
          this.infoCtrl = type !== 'edit'
        } else {
          this.infoCtrl = false
          this.state = false
        }
      })
      if (this.defaultData.id) {
        const _url = `/business/case/withdraw/result/${this.defaultData.id}`
        await this.$get(_url).then(res => {
          if (res.code === 0 && res.data) {
            this.defaultData.resultVO = res.data
            this.justShowChangeState = res.data.changeState
            this.justShowReturnState = res.data.returnState
            this.justShowChangeAmout = res.data.changeAmout
            this.justShowReturnAmout = res.data.returnAmout
            this.withdrawId = res.data.withdrawId
            if (res.data.attachmentList) {
              this.resultAttachmentList = [...res.data.attachmentList]
            }
            console.log(this.resultAttachmentList)
          }
        })
      }
      if (this.defaultData) {
        await this.getDetail(this.defaultData)
      }
    },
    // 赋值
    getDetail(value) {
      console.log('value', value)
      const data = JSON.parse(JSON.stringify(value))
      for (const key in this.formValidate) {
        this.formValidate[key] = data[key]
      }
      this.formValidate.member = data.litigantIds.split(',').map(item => {
        return Number(item)
      })
      this.formValidate.nodeData = data.prevNodeIndex
      if (data.attachmentList && data.attachmentList.length > 0) {
        this.defaultList = data.attachmentList.map(item => {
          return {
            fileName: item.fileName,
            mediaType: item.mediaType,
            smallUrl: item.smallUrl,
            url: item.url
          }
        })
      } else {
        this.defaultList = []
      }

      this.formValidate.attachmentList = this.defaultList

      // 第二个接口补充信息
      this.formValidate.changeState = String(data.resultVO.changeState)
      this.formValidate.returnState = String(data.resultVO.returnState)
      this.formValidate.changeAmout = (data.resultVO.changeAmout)
      this.formValidate.returnAmout = (data.resultVO.returnAmout)
      if (data.resultVO.attachmentList && data.resultVO.attachmentList.length > 0) {
        this.defaultListAtt = data.resultVO.attachmentList.map(item => {
          return {
            fileName: item.fileName,
            mediaType: item.mediaType,
            smallUrl: item.smallUrl,
            url: item.url
          }
        })
      } else {
        this.defaultListAtt = []
      }

      this.formValidate.attachmentListAtt = this.defaultListAtt
    },
    // 获取对方当事人
    getLitigantIdArr() {
      const url = `/business/litigants/${this.caseId}/withdraw`
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.litigantIdArr = res.data
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/globalStyle.scss';
@import '../caseCommon.scss';
.withdraw{
    .add-btn{
        &:nth-of-type(2){
            margin-right:10px;
        }
        &:nth-of-type(3){
            margin-right:10px;
        }
    }
    .withdraw-form{
        margin-top:10px;
        border-top:1px solid $borderColor;
        padding-top:10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/listOptions/withdraw.vue